"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var b=require("react"),a=a=>{var c=b.useRef(a);return b.useEffect(()=>{c.current=a}),c};exports.default=a
//# sourceMappingURL=index.mjs.js.map
